import { inject, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { notification$ } from '@helpers/engine/notify';
import { LoggerService } from '@services/logger.service';

@Injectable({
  providedIn: 'root',
})
export class NotifyService {
  private logger = inject(LoggerService);
  private toast = inject(ToastrService);

  async init() {
    notification$.subscribe((messageData) => {
      const { message, type, onClick } = messageData;
      this.logger.debug(`Notify:${type}`, message);

      const toast = this.toast?.[type]?.(message);
      if (onClick) toast?.onTap.subscribe(onClick);
    });
  }
}
